module.exports = __webpack_public_path__ + "static/media/iphone_screen10.a31f6ad4.png";